import React, { useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import HomeIcon from "@mui/icons-material/Home";
import EmailIcon from "@mui/icons-material/Email";
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";
import ViewListIcon from "@mui/icons-material/ViewList";
import Update from "@mui/icons-material/Update";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Divider } from "@mui/material";
import Badge from "@mui/material/Badge";
import InfoIcon from "@mui/icons-material/Info";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import About from "../../pages/About";
import { logout } from "../../actions/middleware_actions";
import mapStateToProps from "../../services/mapStateToProps";
import { useViewport } from "../CustomHooks/useViewport";
import { newBroadcastedMessages } from "../../constants/default_request";
import { withRouter } from "../CustomHooks/withRouter";

const BottomNav = ({
  isAuthUser,
  client_id,
  user_full_name,
  userLogout,
  updateChecker,
}) => {
  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);
  const [showAbout, setShowAbout] = useState(false);
  const navigate = useNavigate();
  // * Added useMemo to cache the assignment and avoid the ui from re-renders
  const pathMap = useMemo(
    () => [
      `${process.env.PUBLIC_URL}/home`,
      `${process.env.PUBLIC_URL}/broadcasted-messages`,
      `${process.env.PUBLIC_URL}/start-new-trip`,
      `${process.env.PUBLIC_URL}/vtr`,
      `${process.env.PUBLIC_URL}/login`,
    ],
    []
  );
  const { pathname } = window.location;
  const width = useViewport();
  const isMobile = width < 620;
  const [noMessages, setNoMessages] = useState(0);
  const newMessages = newBroadcastedMessages(client_id);

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setOpen(open);
  };

  const logoutHandler = (event) => {
    event.preventDefault();
    userLogout();
  };

  const reloadHandler = (event) => {
    event.preventDefault();
    updateChecker();
  };

  const list = () => (
    <div
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
      style={{ width: "100%" }}
    >
      <List>
        <ListItem onClick={() => setShowAbout(true)}>
          <ListItemIcon>{<InfoIcon />}</ListItemIcon>
          <ListItemText primary="About" />
        </ListItem>
        <ListItem component={Link} to={pathMap[3]}>
          <ListItemIcon>
            <ViewListIcon />
          </ListItemIcon>
          <ListItemText primary="Trip List" />
        </ListItem>
        <ListItem component={Link} onClick={reloadHandler}>
          <ListItemIcon>{<Update />}</ListItemIcon>
          <ListItemText primary="Check for Updates" />
        </ListItem>
        <Divider />
        <ListItem component={Link} to={pathMap[4]} onClick={logoutHandler}>
          <ListItemIcon>{<ExitToAppIcon />}</ListItemIcon>
          <ListItemText primary="Logout" />
        </ListItem>
      </List>
    </div>
  );

  const handleChange = (event, value) => {
    setValue(value);

    switch (value) {
      case 0:
        return navigate(pathMap[value], {
          state: { client_id, user_full_name },
        });
      case 1:
      case 2:
        return navigate(pathMap[value]);
      case 3:
        return setOpen(!open);
      default:
        return navigate("/");
    }
  };

  useEffect(() => {
    if (newMessages) {
      setNoMessages(newMessages);
    }
  }, [newMessages]);

  useEffect(() => {
    const newValue = pathMap.indexOf(pathname);
    if (newValue > -1) {
      setValue(newValue);
    }
  }, [pathname, pathMap]);

  return (
    <>
      {isAuthUser && isMobile && (
        <div className="bottomnav">
          <BottomNavigation
            value={value}
            onChange={handleChange}
            sx={{
              position: "fixed",
              bottom: 0,
              textAlign: "center",
              width: "100%",
              height: 80,
              borderTop: "solid 1px #ACACAC",
              borderRadius: "2px",
            }}
            showLabels
          >
            <BottomNavigationAction label="Home" value={0} icon={<HomeIcon />} />
            <BottomNavigationAction
              label={"Messages"}
              value={1}
              icon={
                <Badge badgeContent={newMessages || noMessages} color="secondary">
                  <EmailIcon />
                </Badge>
              }
            />
            <BottomNavigationAction
              label="New Trip"
              value={2}
              icon={<DirectionsBoatIcon />}
            />
            <BottomNavigationAction label="More" value={3} icon={<MoreHorizIcon />} />
          </BottomNavigation>
          <Drawer anchor="bottom" open={open} onClose={toggleDrawer(false)}>
            {list()}
          </Drawer>
          <About showAbout={showAbout} hideAbout={() => setShowAbout(false)} />
        </div>
      )}
    </>
  );
};

const mapDispatchToProps = {
  userLogout: logout,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BottomNav));
